import * as React from 'react';

const SvgFineDining = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={54} height={54} fill="none" {...props}>
    <path
      d="M11.813 52.313h6.75v-6.75a3.376 3.376 0 00-6.75 0v6.75zM1.688 52.313h50.624M20.25 16.875v18.563c0 .931.756 1.687 1.688 1.687H33.75M5.063 52.313V16.874"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47.25 1.688c.931 0 1.688.755 1.688 1.687v48.938H33.75v-33.75c0-.932-.756-1.688-1.688-1.688h-27v-13.5c0-.932.756-1.688 1.688-1.688h40.5zM5.063 25.313H13.5M5.063 32.063H13.5M40.5 11.813h8.438M40.5 18.563h8.438M40.5 25.313h8.438"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgFineDining;
